import { useRef } from 'react';
import toast from 'react-hot-toast';
import '../../../css/Messages.css';
import { useUser } from '../../../hooks/useUser';
import { useMessages } from '../../../hooks/useMessages';
import { uploadNewMessage } from '../../../services/fetch-utils';
import { ChatMessages } from '../../../interfaces/userInterfaces';

export const UploadMessage = () => {
  const { user, isUserProfile } = useUser();
  const { activeChatId, activeOpenChat } = useMessages();

  const chatRef = useRef<HTMLInputElement>(null);
  const newMessageRef = useRef<Omit<ChatMessages, 'id'>>({} as ChatMessages);

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      user &&
      isUserProfile(user) &&
      chatRef?.current?.value !== '' &&
      chatRef.current?.value !== undefined
    ) {
      const newMessage = {
        chat_id: activeChatId,
        sender: user.username,
        receiver: activeOpenChat[activeOpenChat.user_1 === user.username ? 'user_2' : 'user_1'],
        message: chatRef.current.value,
        read: false,
      };

      const uploadMessage = uploadNewMessage(newMessage)
        .catch((error) => error.message)
        .then(() => {
          if (chatRef.current) {
            chatRef.current.value = '';
            newMessageRef.current = {} as ChatMessages;
          }
        });

      toast.promise(uploadMessage, {
        loading: 'Just a moment while we upload your Message',
        success: 'Message successfully uploaded',
        error: 'Oops! Something went wrong. Please try again',
      });
    }
  };

  return (
    <form id="upload-new-message-form" onSubmit={handleSubmit}>
      <label id="message-upload-input">
        <input id="message-input-row" ref={chatRef} type="text"></input>
        {/* <input id="message-input-field" ref={chatRef} type="text"></input> */}
      </label>
      <button className="message-send-btn">Send It</button>
    </form>
  );
};
